<template>
  <div class="editHospital column-me">
    <div class="row-me row-center">
      <div class="row-me row-center flex1">
        <div class="left-div"><span class="red-star">*</span>医院名称：</div>
        <div class="flex1">
          <el-input placeholder="请输入医院名称" style="width: 100%;" clearable v-model="selectItem.name"
                    :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.name)}"
                    maxlength="50"></el-input>
        </div>
      </div>
      <div class="row-me row-center flex1 margin-left60">
        <div class="left-div"><span class="red-star">*</span>医院编码：</div>
        <div class="flex1">
          <el-input placeholder="请输入医院编码" style="width: 100%;" clearable v-model="selectItem.no"
                    :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.no)}"
                    maxlength="50"></el-input>
        </div>
      </div>
    </div>
    <div class="row-me row-center margin-top20">
      <div class="row-me row-center flex1">
        <div class="left-div"><span class="red-star">*</span>药价方案：</div>
        <div class="flex1">
          <el-select placeholder="请选择药价方案" style="width: 100%;" filterable clearable
                     v-model="selectItem.programmeId"
                     :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.programmeId)}">
            <el-option v-for="item in planArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row-me row-center flex1 margin-left60">
        <div class="left-div"><span class="red-star">*</span>库房：</div>
        <div class="flex1">
          <el-select placeholder="请选择库房" style="width: 100%;" filterable clearable
                     v-model="selectItem.pharmacyId"
                     :class="{'red-border':showRedBorder&&this.$method.isEmpty(selectItem.pharmacyId)}">
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row-me row-center margin-top20">
      <div class="row-me row-center flex1">
        <div class="left-div">联系人：</div>
        <div class="flex1">
          <el-input placeholder="请输入联系人" style="width: 100%;" clearable v-model="selectItem.contact">
          </el-input>
        </div>
      </div>
      <div class="row-me row-center flex1 margin-left60">
        <div class="left-div">联系电话：</div>
        <div class="flex1">
          <el-input placeholder="请输入联系电话" style="width: 100%;" clearable v-model="selectItem.mobile">
          </el-input>
        </div>
      </div>
    </div>
    <div class="row-me row-center margin-top20">
      <div class="row-me row-center flex1">
        <div class="left-div">电子邮箱：</div>
        <div class="flex1">
          <el-input placeholder="请输入电子邮箱" style="width: 100%;" clearable v-model="selectItem.email">
          </el-input>
        </div>
      </div>
      <div class="row-me row-center flex1 margin-left60">
        <div class="left-div">回传地址：</div>
        <div class="flex1">
          <el-input placeholder="请输入回传地址" style="width: 100%;" clearable v-model="selectItem.callbackUrl">
          </el-input>
        </div>
      </div>
    </div>
    <div class="row-me row-center margin-top20">
      <div class="left-div">备注：</div>
      <div class="flex1">
        <el-input placeholder="请输入备注" style="width: 100%;" clearable v-model="selectItem.remark"
                  maxlength="200">
        </el-input>
      </div>
    </div>
    <div class="row-me row-center flex-end1 margin-top80">
      <div class="btn-blank width140 btn-height40" @click="clickReset">取消</div>
      <div class="btn-blue width140 btn-height40 margin-left20" @click="clickSave">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    id: {
      type: Number,
      default: -1,
    }
  },
  data() {
    return {
      selectItem: {
        name: '',
        no: '',
        programmeId: '',
        pharmacyId: '',
        contact: '',
        mobile: '',
        email: '',
        callbackUrl: '',
        remark: '',
      },
      showRedBorder: false,
      planArray: [],
      houseArray: [],
    }
  },
  // html加载完成之前
  created() {
    this.getHouseArray()
    this.getPlanArray()
    if (this.id !== '' && this.id !== -1) {
      this.getData()
    }
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    //重置
    clickReset() {
      this.bus.$emit('addHospital', 'refresh')
    },
    //保存
    clickSave() {
      if (this.$method.isEmpty(this.selectItem.name) || this.$method.isEmpty(this.selectItem.no) ||
          this.$method.isEmpty(this.selectItem.programmeId) || this.$method.isEmpty(this.selectItem.pharmacyId)) {
        this.showRedBorder = true
        return;
      }
      this.$postRequest('/admin/hospital/update', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.bus.$emit('addHospital', 'refresh')
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取药价方案
    getPlanArray() {
      this.$getRequest('/admin/scheme/page', {}).then((res) => {
        if (res) {
          this.planArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/hospital/get/' + this.id, {}).then((res) => {
        if (res) {
          this.selectItem = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取库房
    getHouseArray() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.editHospital {
  padding: 20px;
  overflow: auto;
  color: #181E2B;

  .left-div {
    width: 120px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
